import { useBlocksConfig } from "@pathwright/blocks-engine"
import { BlockText } from "@pathwright/blocks/src/shared"
import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"
import { Col, Row } from "./ui"

const StyledBlocksText = styled(BlockText)`
  &.ql-editor ol li:not(.ql-direction-rtl):not(class^="ql-indent"),
  &.ql-editor ul li:not(.ql-direction-rtl):not(class^="ql-indent") {
    padding-left: 0;
  }
`

const TextView = ({ data, layout }) => {
  const { templateVariables } = useBlocksConfig()

  switch (layout) {
    case "two-column":
      return (
        <Content.Container>
          <Row>
            <Col>
              <StyledBlocksText
                html={data.html}
                templateContext={templateVariables}
              />
            </Col>
            <Col>
              <StyledBlocksText
                html={data.aside}
                templateContext={templateVariables}
              />
            </Col>
          </Row>
        </Content.Container>
      )
    default:
      return (
        <Content.Container flexForPrint={true}>
          <StyledBlocksText
            html={data.html}
            templateContext={templateVariables}
          />
        </Content.Container>
      )
  }
}

export default TextView
